import authAxios from 'src/modules/shared/axios/authAxios';
import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';

export default class ObjectiveService {
  static async update(id, data) {
    const body = {
      id,
      data,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.put(
      `/tenant/${tenantId}/objective/${id}`,
      body,
    );

    return response.data;
  }

  static async destroyAll(ids) {
    const params = {
      ids,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.delete(
      `/tenant/${tenantId}/objective`,
      {
        params,
      },
    );

    return response.data;
  }

  static async create(data) {
    const body = {
      data,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.post(
      `/tenant/${tenantId}/objective`,
      body,
    );

    return response.data;
  }

  static async import(values, importHash) {
    const body = {
      data: values,
      importHash,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.post(
      `/tenant/${tenantId}/objective/import`,
      body,
    );

    return response.data;
  }

  static async find(id) {
    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.get(
      `/tenant/${tenantId}/objective/${id}`,
    );

    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.get(
      `/tenant/${tenantId}/objective`,
      {
        params,
      },
    );

    return response.data;
  }

  static async listAutocomplete(query, limit) {
    const params = {
      query,
      limit,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.get(
      `/tenant/${tenantId}/objective/autocomplete`,
      {
        params,
      },
    );

    return response.data;
  }

  static async summarise(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.get(
      `/tenant/${tenantId}/objective/summarise`,
      {
        params,
      },
    );

    return response.data;
  }

  static async findAnalyticsMilestoneProgress(filter) {
    const tenantId = AuthCurrentTenant.get();

    const params = {
      filter,
    };

    const response = await authAxios.get(
      `/tenant/${tenantId}/objective/analytics/milestoneProgress`,
      {params},
    );

    return response.data;
  }

  static async findAnalyticsBySector(filter) {
    const tenantId = AuthCurrentTenant.get();

    const params = {
      filter,
    };

    const response = await authAxios.get(
      `/tenant/${tenantId}/objective/analytics/bySector`,
      {params},
    );

    return response.data;
  }

  static async findAnalyticsBySubtheme(filter) {
    const tenantId = AuthCurrentTenant.get();

    const params = {
      filter,
    };

    const response = await authAxios.get(
      `/tenant/${tenantId}/objective/analytics/bySubtheme`,
      {params},
    );

    return response.data;
  }

  static async findAnalyticsByStage(filter) {
    const tenantId = AuthCurrentTenant.get();

    const params = {
      filter,
    };

    const response = await authAxios.get(
      `/tenant/${tenantId}/objective/analytics/byStage`,
      {params},
    );

    return response.data;
  }

  static async findAnalyticsByObjectiveStatus(filter) {
    const tenantId = AuthCurrentTenant.get();

    const params = {
      filter,
    };

    const response = await authAxios.get(
      `/tenant/${tenantId}/objective/analytics/byObjectiveStatus`,
      {params},
    );

    return response.data;
  }

}
